export default __webpack_public_path__ + "static/spot-inflammation-070e808e486e0df7b79e0efa255fcfc9.jpg";